import { initialise } from "./";
import { CLEAR_PERSISTENT_ERRORS } from "../../../modules/common/constants";
import { RESET_INITIALISATION_SIMILAR_ITEMS } from "../../../modules/similarItems/constants";

export const reinitialise = () => dispatch => {
  dispatch({ type: RESET_INITIALISATION_SIMILAR_ITEMS });
  dispatch({ type: CLEAR_PERSISTENT_ERRORS });
  dispatch(initialise());
};
